import React from 'react';

const ApplicationNavbarContext = React.createContext();

export default ApplicationNavbarContext;
